// extracted by mini-css-extract-plugin
export default {"container":"container__YDmfT7Fl","close":"close__hxChvqYT","title":"title__xhd771At","body":"body__dX9xf6vd","link":"link__nWWzFPjH","modal":"modal__F6I744j_"};